import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, TextField, Tooltip ,MenuItem} from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import React, { useRef, useState } from "react";
import { SITEWEB_SERVER_BASE_URL } from "../../util/apiClient";
import { useSelector } from 'react-redux';
import { IReduxState } from '../../store';

interface IEddProps {
  editActualite: IEditionPayload;
  setEditActualite: (x: IEditionPayload) => void;
  selectedPhoto: any;
  setSelectedPhoto: (x: any) => void;
}


export interface IEditionPayload {
  titre: string;
  sousTitre: string;
  dateActualite: string;
  actualiteImageEnBase64: string;
  texteComplet: string;
  actualiteImage: string;
}

const Edit = (props: IEddProps) => {

  //props
  const {
    editActualite,
    setEditActualite,
    setSelectedPhoto
  } = props

//
  //hooks
  const selectPhoto: any = useRef(null);
  const [image, setImage] = useState<string>("");


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setEditActualite({ ...editActualite, [name]: value })
  }



  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={4} xs={12} sm={4}>
          <TextField
            fullWidth
            size="small"
            name="titre"
            label="Titre"
            value={editActualite.titre}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={4} xs={12} sm={4}>
          <TextField
            fullWidth
            size="small"
            name="sousTitre"
            label="Sous titre"
            value={editActualite.sousTitre}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={4} xs={12} sm={4}>
          <TextField
            fullWidth
            size="small"
            name="dateActualite"
            type="date"
            helperText="Date de l'évènement"
            value={editActualite.dateActualite}
            onChange={handleInputChange}
          />
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <Grid item md={12} xs={12} sm={12}>
              <img
                src={
                  Object.keys(image).length > 0
                    ? image
                    : `${SITEWEB_SERVER_BASE_URL}/actualitesImages/${editActualite.actualiteImage}`
                }
                style={{ width: "30vw", height: "30vh" }}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger l'image descriptive de l'actualité">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ImageIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectPhoto?.current?.click();
                  }}
                >
                  Charger l'image
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="pieceJointe"
                ref={selectPhoto}
                onChange={(e: any) => {
                  const files = e.target.files[0];
                  if (files) {
                    const img = URL.createObjectURL(files);
                    setImage(img);
                    setSelectedPhoto(e.target.files[0]);
                  }
                }}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Divider />
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
          >
            <Grid item md={12} xs={12} sm={12}>
              <TextField
                // fullWidth
                style={{ width: "90%" }}
                multiline
                minRows={10}
                name="texteComplet"
                label="Saisir le texte complet"
                value={editActualite.texteComplet}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Grid>

      </Grid>

    </Box>

  );
};

export default Edit;





